import { toast } from "@jsq/ds/core";

/** Re-run a `refetch` and toast on failure so post-mutation refreshes
 * never silently swallow errors. */
export const safeRefetch = async (
  refetch: () => Promise<unknown>,
  /** Resource label for the fallback toast, e.g. "data package". */
  resourceLabel: string,
): Promise<void> => {
  try {
    await refetch();
  } catch {
    toast.error(`Failed to refresh ${resourceLabel}. Please reload the page.`);
  }
};
